import { DownOutlined, MenuOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import styled, { useTheme } from 'styled-components';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import { device, useMedia } from '../../core/designSystem/device';
import { LXh4 } from '../../core/texts/lxText';
import { ReactComponent as KlabLogo } from '../assets/klabLogoWhite.svg';
import TestRequestButtons from './testRequestButtons';

const NavContainer = styled.div`
  max-width: 1090px;
  width: 100%;
  padding: 0 25px;
  height: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${device.desktop} {
    height: 88px;
  }
`;

interface BannerNavPropsType {
  onClickHambergurMenu: () => void;
}

const BannerNav = (props: BannerNavPropsType) => {
  const theme = useTheme();
  const { isTabletAndBelow } = useMedia();

  const NavMenus = () => (
    <Row alignItems="center">
      <Dropdown>
        <>
          <LXh4 fontWeight={400} color={theme.colors.white}>
            {theme.intro.productAndServices}
          </LXh4>
          <SizedBox width={6} />
          <DownOutlined style={{ color: `${theme.colors.placeHolder}` }} />
        </>
      </Dropdown>
      <SizedBox width={34} />
      <Dropdown>
        <>
          <LXh4 fontWeight={400} color={theme.colors.white}>
            {theme.intro.news}
          </LXh4>
          <SizedBox width={6} />
          <DownOutlined style={{ color: `${theme.colors.placeHolder}` }} />
        </>
      </Dropdown>
      <SizedBox width={34} />
      <TestRequestButtons />
    </Row>
  );

  const HambergerMenu = () => (
    <MenuOutlined
      onClick={props.onClickHambergurMenu}
      style={{
        color: 'white',
        fontSize: '24px',
        alignSelf: 'flex-end',
      }}
    />
  );

  return (
    <NavContainer>
      <Row justifyContent="space-between" alignItems="center">
        <KlabLogo width={'107px'} height={'40px'} />
        {isTabletAndBelow ? <HambergerMenu /> : <NavMenus />}
      </Row>
    </NavContainer>
  );
};

export default BannerNav;
